<template>
  <div class="home page-tab">
    <Navbar :appTitle="title" :rtitle="rtitle" :rname="rname" />
    <div class="haveBgc">
      <div class="infoBox">
        <img
          :src="`${userInfo.avatar}`"
          alt=""
          v-if="userInfo.avatar"
          class="infoLeft"
        />
        <img src="@/assets/img/touxiang.png" alt="" v-else class="infoLeft" />
        <div class="infoRight">
          <div class="rightTop">{{ userInfo.realname }}</div>
          <div class="rightBot" v-if="userInfo.deptName">
            {{ userInfo.deptName }}
          </div>
        </div>
      </div>
      <!-- <div class="itemBox" @click="routerChange('/feedback')">
        <div class="itemLeft">
          <img src="~@/assets/img/note.png" alt="" class="leftImg" />
          <div class="leftText">意见反馈</div>
        </div>
        <img src="~@/assets/img/goNext.png" alt="" class="goNext" />
      </div>
      <div class="itemBox" @click="routerChange('/consult')">
        <div class="itemLeft">
          <img src="~@/assets/img/phone.png" alt="" class="leftImg" />
          <div class="leftText">业务咨询</div>
        </div>
        <img src="~@/assets/img/goNext.png" alt="" class="goNext" />
      </div> -->
      <van-button v-if="BROWSER" class="button" type="info" @click="logOut" :loading="loadingOut">退出</van-button>
      <div style="height:1.7rem;width:100%" v-else></div>
      <div class="explanBox">
        <div class="pubText">安徽来睿科技有限公司</div>
        <div class="pubText">提供技术支持</div>
      </div>
    </div>
    <TabBar></TabBar>
  </div>
</template>

<script>
import Vue from 'vue'
import Navbar from "@/components/navBar/navBar_right";
import TabBar from "@/components/TabBar";
import { mapActions } from "vuex";
import { apiBaseUrlDownload } from "@/utils/request";
import {PLATFORM_BROWSER} from '@/store/mutation-types'
export default {
  components: { Navbar, TabBar },
  data() {
    return {
      title: "我的",
      apiBaseUrlDownload,
      rtitle: "",
      rname: "", //search
      userInfo: {},
      loadingOut: false,
      BROWSER: true
    };
  },
  created() {
    this.BROWSER = Vue.ls.get(PLATFORM_BROWSER) == 'BROWSER';
    this.userInfo = JSON.parse(
      localStorage.getItem("pro__Login_Userinfo")
    ).value;
  },
  methods: {
    ...mapActions(["Logout"]),
    logOut() {
      this.loadingOut = true
      this.$store.dispatch("Logout").then(() => {
        this.$router.replace('/user/login')
      });
    },
    routerChange(type) {
      this.$router.push({ path: type });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";
.haveBgc {
  width: 100%;
  height: calc(100vh - 0.9rem);
  background: url("../../assets/img/mineBgc.png") no-repeat center/cover;
  box-sizing: border-box;
  padding: 0 0.18rem;
  padding-top: 0.5rem;
}
div.infoBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.5rem;
  img.infoLeft {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 0.06rem;
    margin-right: 0.21rem;
  }

  div.infoRight {
    height: 0.55rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    div.rightTop {
      font-size: 0.18rem;
      font-weight: 500;
      color: #191f25;
    }

    div.rightBot {
      border: 0.01rem dashed #1890ff;
      border-radius: 0.02rem;
      box-sizing: border-box;
      padding: 0.03rem 0.04rem;
      font-size: 0.11rem;
      color: #1890ff;
    }
  }
}
div.itemBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0.22rem 0.15rem;
  background-color: #f5f8ff;
  margin-top: 0.16rem;
  div.itemLeft {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img.leftImg {
      width: 0.22rem;
      height: 0.22rem;
      margin-right: 0.08rem;
    }

    div.leftText {
      font-size: 0.16rem;
      font-weight: 500;
      color: #191f25;
    }
  }
}
.explanBox {
  font-size: 0.11rem;
  color: #888888;
  line-height: 0.18rem;
  text-align: center;
  margin-top: 0.25rem;
}
.button {
  width: 100%;
  margin-top: 1.7rem;
  // margin-top: 0.16rem;
}
</style>
